import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import ProfilInfos from "../../components/profils/profilinfos";
import RulesProfil from "../../components/rules/rulesprofil";
import UserContext from "../../contexts/UserContext";



export default function ViewProfil() {
    // states
    let codeprofil = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [space, setSpace] = useState("");


    const getProfil = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/${codeprofil.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setSpace(body?.codeespacetravail);

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("response", response);
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
    }



    const displayPages = () => {
        if (page === 0) {
            return <ProfilInfos codeprofil={codeprofil.code} />;
        } else {
            return <RulesProfil profil={codeprofil.code} space={space} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {
        getProfil();
    }, []);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-2 font-weight-bold text_primary">Profiles</h1>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                    <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Profiles informations</span>
                    </button>
                    <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Privileges</span>
                    </button>
                </div>
                {displayPages()}
            </div>}
        </>
    )
}